// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.postPhotoItemStyle {

}

.postPhotoItemStyle .closerImage {
  width: 100%;
  display: inline-block;
  position: relative;
}

.postPhotoItemStyle .image {
  width: 100%;
  height: 220px;
  border-radius: 12px;
  object-fit: cover;
}

.postPhotoItemStyle .closeIcon {
  position: absolute;
  top: 4px;
  right: 4px;
}

.postPhotoItemStyle textarea{
    margin: 12px 0;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2) ;
    border-radius: 12px;
    padding: 8px;
    max-lines: 3;
}

.postPhotoItemStyle .bottom{
    display: flex;
    justify-content: space-between;
}

.postPhotoItemStyle .location{
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/styles/postPhotoItemStyle.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,qCAAqC;IACrC,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".postPhotoItemStyle {\r\n\r\n}\r\n\r\n.postPhotoItemStyle .closerImage {\r\n  width: 100%;\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.postPhotoItemStyle .image {\r\n  width: 100%;\r\n  height: 220px;\r\n  border-radius: 12px;\r\n  object-fit: cover;\r\n}\r\n\r\n.postPhotoItemStyle .closeIcon {\r\n  position: absolute;\r\n  top: 4px;\r\n  right: 4px;\r\n}\r\n\r\n.postPhotoItemStyle textarea{\r\n    margin: 12px 0;\r\n    width: 100%;\r\n    border: 1px solid rgba(0, 0, 0, 0.2) ;\r\n    border-radius: 12px;\r\n    padding: 8px;\r\n    max-lines: 3;\r\n}\r\n\r\n.postPhotoItemStyle .bottom{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.postPhotoItemStyle .location{\r\n    display: flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
